import { render, staticRenderFns } from "./custom_form_input.vue?vue&type=template&id=b40b0fac&scoped=true&"
import script from "./custom_form_input.vue?vue&type=script&lang=js&"
export * from "./custom_form_input.vue?vue&type=script&lang=js&"
import style0 from "./custom_form_input.vue?vue&type=style&index=0&id=b40b0fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40b0fac",
  null
  
)

export default component.exports